import { useEffect, useState } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import ButtonBase from '@zenbusiness/zui/ButtonBase';
import Collapse from '@zenbusiness/zui/Collapse';
import ListItem from '@zenbusiness/zui/ListItem';

import LinkMenuItem from './LinkItem';
import * as Styled from './MenuItem.style';
import MenuItemBody from './MenuItemBody';
import { Icon } from '../Icon';
import { MenuItemProps } from './utils/contants';

/**
 * ExpandableMenuItem
 *
 * @param {import('./MenuItem.ts').NavMenuItem} props
 * @returns {import('react').ReactNode}
 */

function ExpandableMenuItem(props) {
  const {
    eventProps = {},
    expanded,
    itemAttributes,
    links,
    onClick
  } = props;

  const { pathname } = useLocation();
  const [active, setActive] = useState(false);

  const handleButtonTracking = useButtonPressedCallback(eventProps);
  const handleOnClickButton = () => {
    handleButtonTracking();
    onClick?.();
    document.activeElement.blur();
  };

  useEffect(() => {
    if (links) {
      const parent = links.some((item) => item?.path === pathname);
      setActive(parent);
    }
  }, [pathname, links]);

  return (
    <ListItem
      disablePadding
      {...itemAttributes}
    >
      <Styled.Button
        className={clsx({ active, opened: expanded }, 'menu-item')}
        component={ButtonBase}
        onClick={handleOnClickButton}
        selected={expanded}
      >
        <MenuItemBody {...props} />
        <Icon
          className="expand"
          onClick={onClick}
          src="arrow-sm-down-outline.svg"
        />
      </Styled.Button>

      <Collapse in={expanded}>
        <Styled.SubMenu component="ul">
          {links.map((menuItem) => (
            <LinkMenuItem
              eventProps={{
                ...eventProps,
                elementName: menuItem.itemId ? `entity_nav_item_${menuItem.itemId}` : undefined,
                elementText: menuItem.title
              }}
              isChild
              expanded={expanded}
              key={menuItem.title}
              onClick={() => onClick(false)}
              {...menuItem}
            />
          ))}
        </Styled.SubMenu>
      </Collapse>
    </ListItem>
  );
}

ExpandableMenuItem.propTypes = {
  ...MenuItemProps,
  expanded: PropTypes.bool
};

export default ExpandableMenuItem;
